import { $t } from '@/utils/languageAuto';
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.define-property";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.exec";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.replace";
import { __awaiter, __decorate, __extends, __generator } from "tslib";
import { Vue, Component } from 'vue-property-decorator';
import SearchBox from '../components/searchBox.vue';

var default_1 = function (_super) {
  __extends(default_1, _super);

  function default_1() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.document = document;
    _this.resultList = [];
    _this.isPending = false;
    _this.page = 1;
    _this.pageSize = 10;
    _this.total = 0;
    return _this;
  }

  Object.defineProperty(default_1.prototype, "keyword", {
    get: function get() {
      return this.$route.query.keyword || '';
    },
    set: function set(value) {
      return value;
    },
    enumerable: false,
    configurable: true
  });

  default_1.prototype.created = function () {
    if (!this.keyword) {
      this.$message.info($t("\u8DEF\u7531\u9700\u8981\u641C\u7D22\u8BCDkeyword"));
    } else {
      this.querySearchList(this.keyword);
    }
  };

  default_1.prototype.handleSearch = function (val) {
    this.querySearchList(val);
    this.keyword = val;
    this.$router.push({
      name: 'SearchResult',
      query: {
        keyword: val
      }
    });
  };

  default_1.prototype.handlePageChange = function (val) {
    this.page = val;
    this.querySearchList(this.keyword);
  };

  default_1.prototype.querySearchList = function (keyword) {
    return __awaiter(this, void 0, Promise, function () {
      var resData, _a, data, _b, total;

      var _this = this;

      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            this.isPending = true;
            return [4, this.$api.helpCenter.querySearchList({
              keyword: keyword,
              page_size: this.pageSize,
              page_index: this.page,
              pre_tags: '<em class=\'highlight-text\'>',
              post_tags: '</em>'
            })];

          case 1:
            resData = _c.sent().data;
            this.isPending = false;
            _a = resData.data, data = _a === void 0 ? [] : _a, _b = resData.total, total = _b === void 0 ? 0 : _b;
            this.total = total;
            this.resultList = data.map(function (item) {
              var reg = new RegExp("(" + _this.$util.escapeRegExp(_this.keyword) + ")", 'g');
              item.title_parsed = item.title.replace(reg, "<em>$1</em>");
              item.content_parsed = item.content_outline.replace(reg, "<em>$1</em>");
              return item;
            });
            return [2];
        }
      });
    });
  };

  default_1.prototype.handleJumpToDetail = function (item) {
    return __awaiter(this, void 0, void 0, function () {
      return __generator(this, function (_a) {
        this.$router.push({
          name: 'FaqDetailPage',
          query: {
            cate_id: String(item.cateId),
            id: String(item.id),
            channel: String(item.channel)
          }
        });
        return [2];
      });
    });
  };

  default_1 = __decorate([Component({
    components: {
      SearchBox: SearchBox
    }
  })], default_1);
  return default_1;
}(Vue);

export default default_1;